import { appendLangCode } from './append-lang-code';
import { hasLangCodeParam } from './has-lang-code-param';

export const setLangCode = (url: string, langCode: string) => {
  if (hasLangCodeParam(url)) return url;
  return appendLangCode(url, langCode);
};
